import { useMediaQuery } from '@mui/material';
import React from 'react';
import Theme from '@kyruus/ui-theme';

/**
 * Wrapper component for provider tiles that conditionally applies mouse event handlers
 * based on the isProviderListMapsEnabled prop.
 *
 * @param {Object} props - Component props
 * @param {Function} props.onMouseEnter - Mouse enter event handler
 * @param {Function} props.onMouseLeave - Mouse leave event handler
 * @param {boolean} props.isProviderListMapsEnabled - Flag to enable/disable provider list maps
 * @param {ReactNode} props.children - Child elements to render
 *
 * @returns {JSX.Element}
 */
export const ProviderTileWrapper = ({
  onMouseEnter,
  onMouseLeave,
  isProviderListMapsEnabled,
  children,
  ...props
}) => {
  const isScreenMediumOrAbove = useMediaQuery(
    `(min-width:${Theme.screen_medium})`
  );

  return isProviderListMapsEnabled && isScreenMediumOrAbove ? (
    <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} {...props}>
      {children}
    </div>
  ) : (
    <div {...props}>{children}</div>
  );
};
